module.exports = __webpack_public_path__ + "static/media/i-fb.ec1fa869.svg";